import { IconBack } from "@suse-o11y/icons";
import { useDelayed } from "@suse-o11y/use-delayed";
import React from "react";

import { useGoBackInChain } from "../../../../app/state/right-pane/hooks";
import { Tooltip } from "../../../../components/react/tooltip/Tooltip";

export const EastPaneBackButton: React.FC<{
	compact?: boolean;
}> = ({ compact = false }) => {
	const goBackInChain = useGoBackInChain();
	const delayedCompact = useDelayed(compact, 500, {
		fallback: true,
	});

	return (
		<Tooltip title="Back to previous selection">
			<button
				className="mr-1 -ml-2 inline-flex h-[38px] cursor-pointer items-center justify-center gap-2 rounded-sm border border-transparent border-solid bg-grey-200 px-1 py-0 text-grey-900 text-lg leading-none transition hover:text-primary-500 focus-visible:border-primary-500 focus-visible:text-primary-500"
				data-testid="east-pane-back-button"
				onClick={goBackInChain}
				tabIndex={0}
				type="button"
			>
				<IconBack />

				{!delayedCompact && <span className="text-13 underline">Previous</span>}
			</button>
		</Tooltip>
	);
};
